import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Landmark, CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function ConnectReturn() {
  const { outcome } = useParams(); // "return" | "refresh"
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (outcome === "refresh") {
      // user needs to restart onboarding
      api.genConnectStart(window.location.origin).then((r) => { window.location.href = r.url; }).catch(() => setStatus("error"));
      return;
    }
    api.genConnectStatus().then((s) => setStatus(s.ready ? "ready" : "pending")).catch(() => setStatus("error"));
  }, [outcome]);

  const icon = { checking: <Loader2 size={44} className="text-primary-400 animate-spin" />, ready: <CheckCircle2 size={44} className="text-green-400" />, pending: <Landmark size={44} className="text-orange-400" />, error: <AlertCircle size={44} className="text-red-400" /> }[status];
  const title = { checking: "Checking your account…", ready: "Bank connected!", pending: "Almost there", error: "Something went wrong" }[status];
  const msg = { checking: "One moment…", ready: "Invoice payments will now be paid out to your bank account.", pending: "Your Stripe onboarding isn't fully complete yet. You can finish it from Settings anytime.", error: "We couldn't confirm your connection. Please try again from Settings." }[status];

  return (
    <div className="min-h-screen clean-bg flex items-center justify-center p-6 text-center" data-testid="connect-return">
      <div className="glass-panel rounded-2xl p-10 max-w-md">
        <div className="flex justify-center mb-5">{icon}</div>
        <h1 className="text-xl font-bold text-white mb-2">{title}</h1>
        <p className="text-sm text-zinc-400 mb-7">{msg}</p>
        <button onClick={() => navigate("/app/generator")} className="px-6 py-3 bg-primary-600 text-white rounded-xl font-bold hover:bg-primary-500 transition">Back to Generator</button>
      </div>
    </div>
  );
}
